<template>
  <div
    class="candy-loading-indicator"
    :style="{
      position: 'fixed',
      top: 0,
      right: 0,
      left: 0,
      pointerEvents: 'none',
      width: 'auto',
      height: `${height}px`,
      opacity: isLoading ? 1 : 0,
      zIndex: 999999,
      transition: 'opacity 0.4s',
    }"
  >
    <div
      class="candy-loading-indicator-bar"
      :style="{
        width: `${progress}%`,
        height: '100%',
        background: error ? errorColor : color,
        backgroundSize: '28.28px 28.28px',
        backgroundPosition: '0 0',
        backgroundRepeat: 'repeat',
        transition: 'width 0.2s ease',
        boxShadow: '0 0 10px rgba(255, 0, 0, 0.5)'
      }"
    />
  </div>
</template>

<script setup lang="ts">
interface Props {
  throttle?: number
  duration?: number
  hideDelay?: number
  resetDelay?: number
  height?: number
  color?: string
  errorColor?: string
  estimatedProgress?: (duration: number, elapsed: number) => number
}

const props = withDefaults(defineProps<Props>(), {
  throttle: 200,
  duration: 2000,
  hideDelay: 500,
  resetDelay: 400,
  height: 3,
  color: 'repeating-linear-gradient(45deg, #ff0000, #ff0000 10px, #ffffff 10px, #ffffff 20px)',
  errorColor: 'repeating-linear-gradient(to right, #f87171 0%, #ef4444 100%)',
})

const { progress, isLoading, error } = useLoadingIndicator({
  duration: props.duration,
  throttle: props.throttle,
  hideDelay: props.hideDelay,
  resetDelay: props.resetDelay,
  estimatedProgress: props.estimatedProgress,
})
</script>

